import { space } from '../spacing.js';
export const contentContainer = {
    marginBottom: space.x2,
};
export const legend = {
    marginBottom: space.x3,
};
//# sourceMappingURL=field-set.js.map